import { AcresMapboxLayerIds, AcresMapboxSourceIds } from '@/mapbox-layers';

enum ELEVATION_LAYER {
  CONTOUR = AcresMapboxLayerIds.ELEVATION_CONTOUR,
  CONTOUR_WIDE = AcresMapboxLayerIds.ELEVATION_CONTOUR_WIDE,
  COLOR = AcresMapboxLayerIds.ELEVATION_COLOR,
  SOURCE = AcresMapboxSourceIds.ELEVATION,
}

export default ELEVATION_LAYER;
